export default {
  CONTACT_US: 'Contact Us',
  CONTACT_US_SUBTITLE:
    'Ralali is ready to assist you in growing your business and addressing various business challenges you may encounter.<br /> Our Business Consultants team will contact you shortly.',
  COMPANY_INFORMATION: 'Company Information',
  FIND_US: 'Find Us on Google Maps',
  POPULAR_PRODUCTS: 'Popular Products',
  RECOMMENDATED_PRODUCTS: 'Recommended Products',
  RECOMMENDATED_SUPPLIERS: 'Trusted Suppliers in Ralali',
  PARTNER_RALALI: 'Ralali Partners',
  TRUSTED_SUPPLIERS_DESCRIPTION:
    'Find certified suppliers and distributors. Get products directly from the first hand with large capacity and best prices.',
  LATEST_PRODUCTS: 'Ralali Latest Products',
  CTA_TITLE: 'Start Growing Your Business with Ralali',
  CTA_WHATSAPP: 'Contact via WhatsApp',
  FAQ_DEFAULT_TITLE: 'Frequently asked questions',
  FAQ_SUBTITLE:
    'Need more information? The Ralali team is ready to help.',
  FAQ_CONTACT_TEAM: 'Contact Our Team',
  ARTICLE_EXPOSURE_LABEL: 'Ralali Exposure',
  ARTICLE_TITLE: 'Latest News and Insights',
  SEE_ALL: 'See All',
  PARTNERS_TITLE: 'Trusted by Leading Business Partners',
  ENDS_IN: 'Ends In:',
  HOME_H1: 'Ralali.com - Wholesale B2B Marketplace',
  SERVICES_PROMO_LABEL: 'New Service',
  SERVICES_PROMO_TITLE:
    'RalaliGrow: Scale Your Brand Without Building a New Team',
  SERVICES_PROMO_DESC:
    'An end-to-end distribution service for brands that want to grow in Indonesia and international markets. One partner, all channels running.',
  SERVICES_PROMO_BUTTON: 'Learn More',
  CATEGORY_EXPLORATION_LABEL: 'Category Exploration',
  CATEGORY_EXPLORATION_TITLE: 'Find Solutions for Every Industry',
  CATEGORY_EXPLORATION_SUBTITLE:
    'Explore thousands of top products across industries to support your business operations and supply chain needs.',
  FAQ_LABEL: 'FAQ',
  SELLER_CERTIFIED: 'Certified',
  SELLER_VISIT_STORE_ARIA: 'Visit {{name}} store',
  SELLER_VISIT_PARTNER_STORE_ARIA: 'Visit partner store',
  SELLER_PRODUCT_IMAGE_ALT: 'product',
  SERVICES_GROW_TITLE: 'RalaliGrow',
  SERVICES_GROW_DESC:
    'Manage omnichannel distribution with ease and scale.',
  SERVICES_PLUS_TITLE: 'RalaliPlus',
  SERVICES_PLUS_DESC:
    'Access working capital with a fast and flexible process',
  SERVICES_FOOD_TITLE: 'Ralalifood',
  SERVICES_FOOD_DESC:
    'Ready-to-eat instant meals for business and daily needs',
  SERVICES_MBG_TITLE: 'MBG Solution',
  SERVICES_MBG_DESC:
    'Official supplier for free meal national program.',
}
